import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ADVANCED_EDITOR_WARNING_MESSAGE } from './constants';

const AdvancedEditorWarningOverlay = ({ warningType }) => {
  if (!warningType) return null;

  return (
    <div
      className={classNames('advanced-editor__low-dpi-warning', {
        'is-original-warning': warningType === 'original',
        'is-crop-warning': warningType === 'crop',
      })}
    >
      {ADVANCED_EDITOR_WARNING_MESSAGE}
    </div>
  );
};

AdvancedEditorWarningOverlay.propTypes = {
  warningType: PropTypes.oneOf(['original', 'crop']),
};

AdvancedEditorWarningOverlay.defaultProps = {
  warningType: null,
};

export default AdvancedEditorWarningOverlay;
